import React, { useEffect } from "react";

import ContainedButton from "components/layout/form/containedButton";
import { useGaEvents } from "../hooks/useGaEvents";
import { useQuickBillContext } from "../hooks/useQuickBill";

import {
  Container,
  Header,
  PopupContainer,
  PopupWrapper,
  Title,
  UnitItem,
  UnitItemComplement,
  UnitItemTitle,
  UnitsWrapper,
} from "./styles";

type ModalSelectUnitProps = {
  handleModal: (open: boolean) => void;
};

const ModalSelectUnit = ({
  handleModal,
}: ModalSelectUnitProps): JSX.Element => {
  const { units, selectedUnit, setSelectedUnit, document } =
    useQuickBillContext();

  const {
    viewModalSelectUnit,
    handleSelectUnit,
    handleClickContinueSelectUnit,
  } = useGaEvents();

  const handleCloseModal = async (): Promise<void> => {
    handleModal(false);
  };

  useEffect(() => {
    viewModalSelectUnit(document);
  }, [viewModalSelectUnit]);

  return (
    <PopupWrapper>
      <PopupContainer>
        <Header>
          <Title>Selecione sua unidade para continuar</Title>
        </Header>
        <Container>
          <UnitsWrapper>
            {units?.map((unit) => (
              <UnitItem
                selected={unit?.instanceId === selectedUnit?.instanceId}
                onClick={() => {
                  handleSelectUnit(document, unit);
                  setSelectedUnit(unit);
                }}
              >
                <UnitItemTitle>{unit.condominiumName}</UnitItemTitle>
                <UnitItemComplement>{unit.name}</UnitItemComplement>
              </UnitItem>
            ))}
          </UnitsWrapper>
          <ContainedButton
            block
            type="button"
            continue
            width="100%"
            onClick={() => {
              handleClickContinueSelectUnit(document, selectedUnit);
              handleCloseModal();
            }}
            disabled={!selectedUnit?.instanceId}
          >
            Continuar
          </ContainedButton>
        </Container>
      </PopupContainer>
    </PopupWrapper>
  );
};

export default ModalSelectUnit;
